/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { CurrentMedicinesContainer } from './CurrentMedicinesContainer';
import { CurrentVitalsContainer } from './CurrentVitalsContainer';
import styles from './CurrentFhirPatientContainer.module.scss';
import { showPatientMedicines } from '../permissions';
import { useAppSelector } from '../../../app/hooks';
import { calculateAge } from '../utils/commonFns';
import {
  selectFhirMedicalHx,
  selectFhirMedicines,
  selectFhirProblemList,
  selectFhirVitals,
  selectPatientContext,
} from '../Fhir/fhirSlice';
import { PastMedicalHxContainer } from './PastHx/PastMedicalHxContainer';
import { CurrentProblemListContainer } from '../ProblemList/CurrentProblemListContainer';
import { DocumentVersionType } from '../algorithm/types';

export function CurrentFhirPatientContainer({ documentVersion }: { documentVersion?: DocumentVersionType }) {
  const patientDetails = useAppSelector(selectPatientContext)?.patient;
  const vitals = useAppSelector(selectFhirVitals);
  const medicines = useAppSelector(selectFhirMedicines);
  const problemList = useAppSelector(selectFhirProblemList);
  const medicalHx = useAppSelector(selectFhirMedicalHx);

  const enabled = showPatientMedicines();
  if (!enabled) {
    return null;
  }

  return (
    <div className={`${styles.container} ${styles.columnContainer}`}>
      <div className={styles.header}>
        <div className={styles.headerItems}>
          <div>
            <span>Age:</span>
            {patientDetails?.birthDate ? calculateAge(patientDetails.birthDate) : ''}
          </div>
          <div>
            <span>Gender:</span>
            {patientDetails?.gender && patientDetails?.gender.charAt(0).toUpperCase() + patientDetails?.gender.slice(1)}
          </div>
          {/* <div>
            <span>Preferred pronouns:</span>
            {getPreferredPronoun(patientDetails?.extension)}
          </div> */}
        </div>
      </div>
      <div className={styles.fhirPatientContainer}>
        {vitals && <CurrentVitalsContainer documentVersion={documentVersion} vitals={vitals} />}
        {medicines && <CurrentMedicinesContainer documentVersion={documentVersion} />}
        {problemList && <CurrentProblemListContainer documentVersion={documentVersion} />}
        {medicalHx && <PastMedicalHxContainer documentVersion={documentVersion} />}
      </div>
    </div>
  );
}
